module.exports = __webpack_public_path__ + "img/c1-pop1.e0c6db46.png";